// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bewertung-frageboegen-screen{
  position: relative;
  /*TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}

/* SIDE SELECTOR START*/

.selector-container{
  position: relative;
  display: flex;
  flex-direction: row;
  top: 35px;
  height: fit-content;
  margin-right: 42px;
  margin-left: 42px;
  border-radius: 10px;
  background: var(--searchbar-background);

  /*Text Font*/
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.selector-item-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  background: var(--white-base);
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-item-not-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-divider {
  width: 1.48px;
  height: 50.8px;
  background-color: var(--gray-20);
  margin: 10px;
}
/* SIDE SELECTOR END */

/* MAIN CONTENT START*/
.fr-singleContent-container {
  position: relative;
  margin-top: 80px;
  margin-left: var(--content-space);
  margin-right: var(--content-space);
  margin-bottom: 118px;
  /* Add vertical gap between children */
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 30px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
}
.fr-singleContent-container-noAssessment {
  position: fixed; /* Change from absolute to fixed */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
  font-size: x-large;
}

  .fr-singleContent-container-selector {
    position: relative;
    margin-right: 0;
    margin-left: auto;
    padding: 0px 5px;
    width: fit-content;
    background-color: var(--gray-20);
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    /* TEXT FONT */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 18px */
  }

  .ba-singleContent-container-selector {
    position: relative;
    margin-right: 0;
    margin-left: auto;
    padding: 5px 10px;
    width: fit-content;
    background-color: var(--gray-20);
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    /* TEXT FONT */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 18px */
  }

  .ba-singleContent-container-selector-item {
    background-color: var(--white-base); /* Background color for options */
    color: var(--gray-40);
  }
/* MAIN CONTENT END*/

.befragung-button{
  position: relative;
  width: fit-content;
  height: fit-content;
  background: var(--blue-60);
  cursor: pointer;

  /* TEXT FONT*/
  text-align: center;
  color: var(--white-base);
  padding: 0px 20px;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  border-radius: 99px;
  /* Hover effect */
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.befragung-button:hover {
  background: var(--blue-50); /* Change the background color on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */
}

.treegraph-content{
  margin: 20px;
  height: 800px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
}


/* Overlay Fragebogen */

.overlay {
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  height: calc(100% - 80px);
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.overlay-iframe-container {
  position: relative;
  display: flex;
  height: 100%;
  background-color: var(--white-base);
  justify-content: center;
  align-items: center;
}

.overlay-iframe {
  overflow: visible;
  border-radius: 15px;
}

.overlay-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ff6347;
  color: white;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.overlay-close-btn:hover {
  background-color: #e55347;
  transform: scale(1.1);
}

.overlay-close-btn::before {
  content: '\\00d7';
  font-size: 32px;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/BewertungFrageboegen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;AACA,sBAAsB;;AAEtB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;EAClC,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,eAAe,EAAE,kCAAkC;EACnD,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;AACpB;;EAEE;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,eAAe;;IAEf,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,eAAe;;IAEf,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;;EAEA;IACE,mCAAmC,EAAE,iCAAiC;IACtE,qBAAqB;EACvB;AACF,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;;EAEf,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B,EAAE,yCAAyC;EACrE,wCAAwC,EAAE,qDAAqD;AACjG;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;;;AAGA,uBAAuB;;AAEvB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".bewertung-frageboegen-screen{\r\n  position: relative;\r\n  /*TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n/* SIDE SELECTOR START*/\r\n\r\n.selector-container{\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  top: 35px;\r\n  height: fit-content;\r\n  margin-right: 42px;\r\n  margin-left: 42px;\r\n  border-radius: 10px;\r\n  background: var(--searchbar-background);\r\n\r\n  /*Text Font*/\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.selector-item-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  background: var(--white-base);\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-item-not-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-divider {\r\n  width: 1.48px;\r\n  height: 50.8px;\r\n  background-color: var(--gray-20);\r\n  margin: 10px;\r\n}\r\n/* SIDE SELECTOR END */\r\n\r\n/* MAIN CONTENT START*/\r\n.fr-singleContent-container {\r\n  position: relative;\r\n  margin-top: 80px;\r\n  margin-left: var(--content-space);\r\n  margin-right: var(--content-space);\r\n  margin-bottom: 118px;\r\n  /* Add vertical gap between children */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n}\r\n.fr-singleContent-container-noAssessment {\r\n  position: fixed; /* Change from absolute to fixed */\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: fit-content;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n  font-size: x-large;\r\n}\r\n\r\n  .fr-singleContent-container-selector {\r\n    position: relative;\r\n    margin-right: 0;\r\n    margin-left: auto;\r\n    padding: 0px 5px;\r\n    width: fit-content;\r\n    background-color: var(--gray-20);\r\n    border-radius: 8px;\r\n    border: none;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    cursor: pointer;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 150%; /* 18px */\r\n  }\r\n\r\n  .ba-singleContent-container-selector {\r\n    position: relative;\r\n    margin-right: 0;\r\n    margin-left: auto;\r\n    padding: 5px 10px;\r\n    width: fit-content;\r\n    background-color: var(--gray-20);\r\n    border-radius: 8px;\r\n    border: none;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    cursor: pointer;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 150%; /* 18px */\r\n  }\r\n\r\n  .ba-singleContent-container-selector-item {\r\n    background-color: var(--white-base); /* Background color for options */\r\n    color: var(--gray-40);\r\n  }\r\n/* MAIN CONTENT END*/\r\n\r\n.befragung-button{\r\n  position: relative;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  background: var(--blue-60);\r\n  cursor: pointer;\r\n\r\n  /* TEXT FONT*/\r\n  text-align: center;\r\n  color: var(--white-base);\r\n  padding: 0px 20px;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n  border-radius: 99px;\r\n  /* Hover effect */\r\n  transition: background 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.befragung-button:hover {\r\n  background: var(--blue-50); /* Change the background color on hover */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */\r\n}\r\n\r\n.treegraph-content{\r\n  margin: 20px;\r\n  height: 800px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n}\r\n\r\n\r\n/* Overlay Fragebogen */\r\n\r\n.overlay {\r\n  position: fixed;\r\n  top: 80px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: calc(100% - 80px);\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n}\r\n\r\n.overlay-iframe-container {\r\n  position: relative;\r\n  display: flex;\r\n  height: 100%;\r\n  background-color: var(--white-base);\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.overlay-iframe {\r\n  overflow: visible;\r\n  border-radius: 15px;\r\n}\r\n\r\n.overlay-close-btn {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: #ff6347;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 35px;\r\n  height: 35px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  font-size: 24px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n  z-index: 10;\r\n}\r\n\r\n.overlay-close-btn:hover {\r\n  background-color: #e55347;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.overlay-close-btn::before {\r\n  content: '\\00d7';\r\n  font-size: 32px;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
